function goToPage(url) {
  // Navigate to a new page
  window.location.href = url;

  // Alternative for opening in a new tab:
  // window.open('https://www.google.com', '_blank');
}

function goToSection(id) {
  // Navigate to a new page
  window.location.hash = id;

  // Alternative for opening in a new tab:
  // window.open('https://www.google.com', '_blank');
}

// --- Navigation Logic ---
        function showPage(pageId, sectionId = null) {
            const views = [
                'home-view', 'product-view', 'commissions-view', 
                'search-view', 'cart-view', 'checkout-view', 
                'contact-view', 'about-view', 'contact-success-view',
                'logo-showcase-view', 'catalog-view', 'empty-cart-view'
            ];
            
            // Hide all
            views.forEach(id => {
                const el = document.getElementById(id);
                if(el) {
                    el.classList.add('hidden');
                    if(id === 'home-view' || id === 'product-view') {
                        el.classList.remove('opacity-100');
                        el.classList.add('opacity-0');
                    }
                }
            });

            // Show selected
            const targetView = document.getElementById(pageId + '-view');
            if (targetView) {
                targetView.classList.remove('hidden');
                
                // Fade effect
                if(pageId === 'home' || pageId === 'product') {
                    setTimeout(() => {
                        targetView.classList.remove('opacity-0');
                        targetView.classList.add('opacity-100');
                    }, 10);
                }
                
                window.scrollTo(0,0);
            }
        }

        function toggleMobileMenu() {
            const menu = document.getElementById('mobile-menu');
            menu.classList.toggle('flex');
        }

        // --- Product Logic ---
        function changeImage(element) {
            const src = element.querySelector('img').src;
            const mainImg = document.getElementById('main-product-image');
            
            // Visual transition
            mainImg.style.opacity = '0.5';
            setTimeout(() => {
                mainImg.src = src;
                mainImg.style.opacity = '1';
            }, 200);

            // Toggle active class on thumbnails
            document.querySelectorAll('.gallery__thumb').forEach(thumb => {
                thumb.classList.remove('gallery__thumb--active');
            });
            element.classList.add('gallery__thumb--active');
        }

        function toggleAccordion(id) {
            const content = document.getElementById(`content-${id}`);
            const icon = document.getElementById(`icon-${id}`);
            
            if (content.style.maxHeight) {
                content.style.maxHeight = null;
                content.classList.remove('active');
                icon.classList.remove('rotate-45');
            } else {
                content.style.maxHeight = content.scrollHeight + "px";
                content.classList.add('active');
                icon.classList.add('rotate-45');
            }
        }

        function openRoomModal() {
            const modal = document.getElementById('room-modal');
            const mainImgSrc = document.getElementById('main-product-image').src;
            const modalImg = document.getElementById('modal-product-image');
            modalImg.src = mainImgSrc;
            modal.style.display = 'block';
        }

        function closeRoomModal() {
            const modal = document.getElementById('room-modal');
            modal.style.display = 'none';
        }

        // --- Quantity Logic ---
        function updateQty(change) {
            const input = document.getElementById('qty-input');
            if (input) {
                let val = parseInt(input.value);
                val += change;
                if (val < 1) val = 1;
                input.value = val;
            }
        }